// @flow
const EVENT_DATA_READY = 'data_ready';
const EVENT_INITIALIZED = 'component_initialized';
const EVENT_JS_READY = 'js_ready';

export { EVENT_DATA_READY, EVENT_INITIALIZED, EVENT_JS_READY };
